import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import Carousel from './Carousel';

const schema: JSONSchema7 = {
    title: 'Carousel',
    type: 'object',
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        dataKey: {
            type: 'string',
            title: 'Data key',
        },
        header: headingsSchema,
        options: {
            type: 'string',
            title: 'Options',
            description: 'Options JSON object',
        },
        isTransformData: {
            type: 'boolean',
            title: 'Is transform Data',
            default: false,
        },
        useExternalIndicators: {
            type: 'boolean',
            title: 'Use external indicators',
            default: false,
        },
        renderViewPoints: {
            type: 'boolean',
            title: 'Render View Points',
            default: false,
        },
        imagesLink: {
            type: 'string',
            title: 'Base images Link',
            description: 'URL for the images',
        },
        imageType: {
            type: 'string',
            enum: ['png', 'jpg', 'svg'],
            title: 'Image Type',
            default: 'png',
        },
    },
    dependencies: {
        isTransformData: {
            oneOf: [
                {
                    properties: {
                        isTransformData: { enum: [true] },
                        functionToTransform: {
                            type: 'string',
                            description: 'Function to transform',
                            default: 'return (data) => { return data }',
                        },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'dataKey',
            'header',
            'options',
            'useExternalIndicators',
            'renderViewPoints',
            'imagesLink',
            'imageType',
        ],
        'Transform Data': ['isTransformData', 'functionToTransform'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    header: {
        items: {
            headerText: {
                'ui:widget': 'ResourcePicker',
            },
        },
    },
    styles: {
        'ui:widget': 'CSSEditor',
    },
    functionToTransform: { 'ui:widget': 'JSEditor' },
};

const CarouselWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: Carousel,
    id: 'Carousel',
    group: 'component',
    contentPlaceHolders: [],
    initialData: () => ({}),
};

export default CarouselWidget;
